import React from 'react';

import { Grid, Typography } from '@mui/material';
import { getTranslate, Translate } from 'react-localize-redux';
import { connect } from 'react-redux';

import PaperContainer from '@fd/ui/Layout/PaperContainer';

type Props = MappedState;

const AppSettings: React.FC<Props> = () => {
  return (
    <PaperContainer fluid>
      <Grid container spacing={3} sx={{ padding: '24px' }}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            <Translate id="App_Settings" />
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            <Translate id="Configure_general_mobile_app_settings" />
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            <Translate id="App_settings_content_placeholder" />
          </Typography>
        </Grid>
      </Grid>
    </PaperContainer>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  translate: getTranslate(state),
});

export default connect(mapStateToProps)(AppSettings);
